import { render, staticRenderFns } from "./CardPowerInfo.vue?vue&type=template&id=257e4956&scoped=true&"
import script from "./CardPowerInfo.vue?vue&type=script&lang=js&"
export * from "./CardPowerInfo.vue?vue&type=script&lang=js&"
import style0 from "./CardPowerInfo.vue?vue&type=style&index=0&id=257e4956&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257e4956",
  null
  
)

export default component.exports